// eslint-disable-next-line consistent-return
const lsAvailable = () => {
    try {
        const lsTest = `test_${Math.random()}`;
        localStorage.setItem(lsTest, lsTest);
        const lsContent = localStorage.getItem(lsTest);
        if (lsContent === lsTest) {
            localStorage.removeItem(lsTest);
            return true;
        }
    }
    catch (e) {
        return false;
    }
};
function getLocalStorageObject(key) {
    const ls = (() => {
        try {
            return lsAvailable() ? window.localStorage : null;
        }
        catch (e) {
            return null;
        }
    })();
    if (ls) {
        try {
            const item = ls.getItem(key);
            return item !== null ? JSON.parse(item) : null;
        }
        catch (e) {
            return null;
        }
    }
    return null;
}
function getLocalStorageString(key) {
    const ls = (() => {
        try {
            return lsAvailable() ? window.localStorage : null;
        }
        catch (e) {
            return null;
        }
    })();
    if (ls) {
        try {
            const item = ls.getItem(key);
            return item !== null ? item : null;
        }
        catch (e) {
            return null;
        }
    }
    return null;
}
function setLocalStorageString(key, value) {
    const ls = (() => {
        try {
            return lsAvailable() ? window.localStorage : null;
        }
        catch (e) {
            return null;
        }
    })();
    if (ls) {
        try {
            ls.setItem(key, value);
        }
        catch (e) {
            console.error("Could not set ls item");
        }
    }
}
export { getLocalStorageObject, getLocalStorageString, setLocalStorageString };
//# sourceMappingURL=localstorage.js.map